import {Selector} from 'notebook/ELNConstants';
import {TableEvaluation, stubbableFunctions} from 'notebook/mediocre/DocumentEvaluationUpdater';
import excess from 'notebook/tables/excess';

import {NoteRuntimeSnapshot} from '../TableStoreTransforms';
import {FullTableMap} from './Evaluator';
import Resolver from './Resolver';

/*
 * Evaluate every cell in the tableMap every time you run evaluation
 */
export const runEvalution = ({
  itemCid,
  fileId,
  fullTableMap,
  selectors,
  noteRuntimeSnapshot,
  tableNameToProvenanceUuid,
}: {
  itemCid: string;
  fileId: string;
  fullTableMap: FullTableMap;
  selectors: Array<Selector>;
  noteRuntimeSnapshot: NoteRuntimeSnapshot;
  tableNameToProvenanceUuid: Record<PropertyKey, string | null>;
}): TableEvaluation => {
  if (window.debug) {
    // eslint-disable-next-line no-console
    console.info(`[EXCESS] [${fileId}] Running traditional evaluator for persistence`);
  }

  const resolver: Resolver = stubbableFunctions.makeResolver(noteRuntimeSnapshot, () => {
    const currentTableName = evaluator.env.currentTable!;
    return (
      tableNameToProvenanceUuid[currentTableName] ??
      // TODO(BNCH-19669): remove this fallback once provenanceUuid is backfilled for legacy results tables
      currentTableName
    );
  });

  const evaluator = new excess.SpreadsheetEvaluator({
    fullTableMap,
    selectors,
    parse: excess.parse,
    resolver,
    fileId,
  });
  const evaluationSnapshot = evaluator.output();
  const {syncResolutions, asyncResolutions} = resolver.getResolutions();
  return {cid: itemCid, evaluationSnapshot, syncResolutions, asyncResolutions};
};
